module.exports = __webpack_public_path__ + "static/media/sales_home_soul.b0a4ea98.png";